//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_REWARDS_BASE_URL = new InjectionToken<string>('API_REWARDS_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class RewardsGameApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param game (optional) 
     * @return Success
     */
    saveGame(game: Game | null | undefined): Observable<Game> {
        let url_ = this.baseUrl + "/api/admin/game";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(game);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGame(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Game>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Game>;
        }));
    }

    protected processSaveGame(response: HttpResponseBase): Observable<Game> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Game.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param consumerId (optional) 
     * @return Success
     */
    getGameByParams(id: string | null | undefined, consumerId: string | null | undefined): Observable<Game> {
        let url_ = this.baseUrl + "/api/admin/game?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (consumerId !== undefined && consumerId !== null)
            url_ += "consumerId=" + encodeURIComponent("" + consumerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGameByParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameByParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Game>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Game>;
        }));
    }

    protected processGetGameByParams(response: HttpResponseBase): Observable<Game> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Game.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param consumerId (optional) 
     * @return Success
     */
    getGameById(id: string, consumerId: string | null | undefined): Observable<Game> {
        let url_ = this.baseUrl + "/api/admin/game/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (consumerId !== undefined && consumerId !== null)
            url_ += "consumerId=" + encodeURIComponent("" + consumerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGameById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Game>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Game>;
        }));
    }

    protected processGetGameById(response: HttpResponseBase): Observable<Game> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Game.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param param (optional) 
     * @return Success
     */
    startGame(param: StartGameParam | null | undefined): Observable<StartGame> {
        let url_ = this.baseUrl + "/api/admin/game/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartGame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartGame(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartGame>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartGame>;
        }));
    }

    protected processStartGame(response: HttpResponseBase): Observable<StartGame> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartGame.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsOrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates an order
     * @param createOrderRequest (optional) 
     * @return Success
     */
    createSimpleOrder(createOrderRequest: CreateSimpleOrderRequest | null | undefined): Observable<RewardInfo> {
        let url_ = this.baseUrl + "/api/admin/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOrderRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSimpleOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSimpleOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardInfo>;
        }));
    }

    protected processCreateSimpleOrder(response: HttpResponseBase): Observable<RewardInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create order (aka redeem a reward) - this uses the coins that the user has
     * @param request (optional) 
     * @return Success
     */
    createOrder(request: CreateOrderRequest | null | undefined): Observable<RewardInfo> {
        let url_ = this.baseUrl + "/api/admin/order/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardInfo>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<RewardInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrder(orderId: string, orderKey: string): Observable<RewardInfo> {
        let url_ = this.baseUrl + "/api/admin/order/{orderId}/{orderKey}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (orderKey === undefined || orderKey === null)
            throw new globalThis.Error("The parameter 'orderKey' must be defined.");
        url_ = url_.replace("{orderKey}", encodeURIComponent("" + orderKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardInfo>;
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<RewardInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    completeOrder(request: CompleteOrderRequest | null | undefined): Observable<RewardInfo> {
        let url_ = this.baseUrl + "/api/admin/order/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardInfo>;
        }));
    }

    protected processCompleteOrder(response: HttpResponseBase): Observable<RewardInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsProductApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all products
     * @return Success
     */
    getAllProducts(): Observable<ProductInfo[]> {
        let url_ = this.baseUrl + "/api/admin/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo[]>;
        }));
    }

    protected processGetAllProducts(response: HttpResponseBase): Observable<ProductInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a reward product. Routed per advertiser (WEE-10314 isolation follow-up):
    advertisers on WooCommerce get the exact same behavior as before; advertisers routed
    to Wecheer get a RewardsCatalog entry instead, with zero WooCommerce calls. See
    RewardService.CreateRewardAsync for the routing logic.
     * @param createProductRequest (optional) 
     * @return Success
     */
    createProduct(createProductRequest: CreateProductRequest | null | undefined): Observable<ProductInfo> {
        let url_ = this.baseUrl + "/api/admin/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProductRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo>;
        }));
    }

    protected processCreateProduct(response: HttpResponseBase): Observable<ProductInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all products by category slug
     * @return Success
     */
    getProductsByCategorySlug(categorySlug: string): Observable<ProductInfo[]> {
        let url_ = this.baseUrl + "/api/admin/product/byCategorySlug/{categorySlug}";
        if (categorySlug === undefined || categorySlug === null)
            throw new globalThis.Error("The parameter 'categorySlug' must be defined.");
        url_ = url_.replace("{categorySlug}", encodeURIComponent("" + categorySlug));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsByCategorySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByCategorySlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo[]>;
        }));
    }

    protected processGetProductsByCategorySlug(response: HttpResponseBase): Observable<ProductInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get products by advertiser id for an explicit staff/consumer audience, routed to the
    Wecheer provider or WooCommerce per the advertiser's Provider Routing Control Panel
    assignment (WEE-10314) - see RewardService.GetProductsByAdvertiserAndAudienceAsync.
    Use this instead of GetProductsByCategorySlug for admin reward pickers (Campaigns
    punch-card/referral/reward-strategy UIs): that endpoint bypasses routing and only ever
    queries WooCommerce, so it can't see products created for advertisers routed to the
    Wecheer provider.
     * @param isStaff (optional)
     * @param onlyPopular (optional)
     * @return Success
     */
    getProductsByAdvertiserId(advertiserId: string, isStaff: boolean | null | undefined, onlyPopular: boolean | null | undefined): Observable<ProductInfo[]> {
        let url_ = this.baseUrl + "/api/admin/product/byAdvertiserId/{advertiserId}?";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (isStaff !== undefined && isStaff !== null)
            url_ += "isStaff=" + encodeURIComponent("" + isStaff) + "&";
        if (onlyPopular !== undefined && onlyPopular !== null)
            url_ += "onlyPopular=" + encodeURIComponent("" + onlyPopular) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsByAdvertiserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByAdvertiserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo[]>;
        }));
    }

    protected processGetProductsByAdvertiserId(response: HttpResponseBase): Observable<ProductInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get product by slug
     * @return Success
     */
    getProductBySlug(slug: string): Observable<ProductInfo> {
        let url_ = this.baseUrl + "/api/admin/product/{slug}";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductBySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductBySlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo>;
        }));
    }

    protected processGetProductBySlug(response: HttpResponseBase): Observable<ProductInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing reward product (name, description, photo URL)
     * @param request (optional) 
     * @return Success
     */
    updateProduct(id: number, request: UpdateProductRequest | null | undefined): Observable<ProductInfo> {
        let url_ = this.baseUrl + "/api/admin/product/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo>;
        }));
    }

    protected processUpdateProduct(response: HttpResponseBase): Observable<ProductInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search products by name
     * @param name (optional) Product name to search for
     * @return Success
     */
    searchProductsByName(name: string | null | undefined): Observable<ProductInfo[]> {
        let url_ = this.baseUrl + "/api/admin/product/search?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProductsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProductsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInfo[]>;
        }));
    }

    protected processSearchProductsByName(response: HttpResponseBase): Observable<ProductInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsRewardCatalogApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a presigned S3 PUT URL for uploading a reward's photo. The frontend uploads
    directly to S3 with this URL, then derives the public photo URL from it (same pattern
    as Products' admin photo upload).
     * @return Success
     */
    getPhotoUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/photo-upload-url/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhotoUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhotoUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPhotoUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(rewardId: string): Observable<RewardDefinitionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/{rewardId}";
        if (rewardId === undefined || rewardId === null)
            throw new globalThis.Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardDefinitionDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<RewardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    update(rewardId: string, request: UpdateRewardDefinitionRequest | null | undefined): Observable<RewardDefinitionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/{rewardId}";
        if (rewardId === undefined || rewardId === null)
            throw new globalThis.Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardDefinitionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RewardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBySlug(slug: string): Observable<RewardDefinitionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/by-slug/{slug}";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardDefinitionDto>;
        }));
    }

    protected processGetBySlug(response: HttpResponseBase): Observable<RewardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param audienceType (optional) 
     * @param onlyPopular (optional) 
     * @return Success
     */
    getByAdvertiser(advertiserId: string, audienceType: any | null | undefined, onlyPopular: boolean | null | undefined): Observable<RewardDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/by-advertiser/{advertiserId}?";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (audienceType !== undefined && audienceType !== null)
            url_ += "audienceType=" + encodeURIComponent("" + audienceType) + "&";
        if (onlyPopular !== undefined && onlyPopular !== null)
            url_ += "onlyPopular=" + encodeURIComponent("" + onlyPopular) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAdvertiser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAdvertiser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardDefinitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardDefinitionDto[]>;
        }));
    }

    protected processGetByAdvertiser(response: HttpResponseBase): Observable<RewardDefinitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RewardDefinitionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search advertisers by name, for the advertiser picker on the reward form. Proxies to
    the Campaigns domain (the source of truth for advertisers) rather than duplicating
    advertiser data here.
     * @param search (optional) 
     * @param maxItems (optional) 
     * @return Success
     */
    searchAdvertisers(search: string | null | undefined, maxItems: number | null | undefined): Observable<AdvertiserSummaryDto[]> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/advertisers?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (maxItems !== undefined && maxItems !== null)
            url_ += "maxItems=" + encodeURIComponent("" + maxItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAdvertisers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAdvertisers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserSummaryDto[]>;
        }));
    }

    protected processSearchAdvertisers(response: HttpResponseBase): Observable<AdvertiserSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvertiserSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param audienceType (optional) 
     * @return Success
     */
    getDistinctCategories(advertiserId: string, audienceType: any | null | undefined): Observable<RewardCategorySummaryDto[]> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/categories/{advertiserId}?";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (audienceType !== undefined && audienceType !== null)
            url_ += "audienceType=" + encodeURIComponent("" + audienceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardCategorySummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardCategorySummaryDto[]>;
        }));
    }

    protected processGetDistinctCategories(response: HttpResponseBase): Observable<RewardCategorySummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RewardCategorySummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    search(query: RewardCatalogQueryDto | null | undefined): Observable<RewardCatalogSearchResponseDto> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardCatalogSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardCatalogSearchResponseDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<RewardCatalogSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RewardCatalogSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    create(request: CreateRewardDefinitionRequest | null | undefined): Observable<RewardDefinitionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewardDefinitionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RewardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RewardDefinitionDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deactivate(rewardId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/{rewardId}/deactivate";
        if (rewardId === undefined || rewardId === null)
            throw new globalThis.Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Drops and recreates the OpenSearch index with the correct field mapping, then
    re-indexes all rewards from DynamoDB. Use to recover from a mapping conflict
    (e.g. enum fields mapped as integer instead of keyword) that causes
    search_phase_execution_exception on every search.
     * @return Success
     */
    reindex(): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/reward-catalog/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReindex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReindex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReindex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsRewardRedemptionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    search2(query: RedemptionQueryDto | null | undefined): Observable<RedemptionSearchResponseDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionSearchResponseDto>;
        }));
    }

    protected processSearch2(response: HttpResponseBase): Observable<RedemptionSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById2(redemptionId: string): Observable<RedemptionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/{redemptionId}";
        if (redemptionId === undefined || redemptionId === null)
            throw new globalThis.Error("The parameter 'redemptionId' must be defined.");
        url_ = url_.replace("{redemptionId}", encodeURIComponent("" + redemptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionDto>;
        }));
    }

    protected processGetById2(response: HttpResponseBase): Observable<RedemptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    putOnHold(redemptionId: string, request: AdminRedemptionActionRequest | null | undefined): Observable<RedemptionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/{redemptionId}/hold";
        if (redemptionId === undefined || redemptionId === null)
            throw new globalThis.Error("The parameter 'redemptionId' must be defined.");
        url_ = url_.replace("{redemptionId}", encodeURIComponent("" + redemptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutOnHold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutOnHold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionDto>;
        }));
    }

    protected processPutOnHold(response: HttpResponseBase): Observable<RedemptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Client Error", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * "Cancel" action from the Redemption Detail screen. Like PutOnHold, this is a terminal
    status change (see RewardRedemptionService.SetStatusAsync remarks) - once cancelled, a
    redemption cannot be put on hold, completed, or cancelled again.
     * @param request (optional) 
     * @return Success
     */
    cancel(redemptionId: string, request: AdminRedemptionActionRequest | null | undefined): Observable<RedemptionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/{redemptionId}/cancel";
        if (redemptionId === undefined || redemptionId === null)
            throw new globalThis.Error("The parameter 'redemptionId' must be defined.");
        url_ = url_.replace("{redemptionId}", encodeURIComponent("" + redemptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionDto>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<RedemptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Client Error", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * "Mark fulfilled" action from the Redemption Detail screen. Delegates to the same
    CompleteRedemptionAsync the consumer-facing staff-scan flow uses, passing a null
    redemptionKey - CompleteRedemptionAsync only checks the key when one is supplied
    (see its remarks), so this is a legitimate admin-override path rather than a bypass.
     * @param request (optional) 
     * @return Success
     */
    markFulfilled(redemptionId: string, request: AdminRedemptionActionRequest | null | undefined): Observable<RedemptionDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/{redemptionId}/complete";
        if (redemptionId === undefined || redemptionId === null)
            throw new globalThis.Error("The parameter 'redemptionId' must be defined.");
        url_ = url_.replace("{redemptionId}", encodeURIComponent("" + redemptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFulfilled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFulfilled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionDto>;
        }));
    }

    protected processMarkFulfilled(response: HttpResponseBase): Observable<RedemptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result412 = ProblemDetails.fromJS(resultData412);
            return throwException("Client Error", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getStats(query: RedemptionStatsQueryDto | null | undefined): Observable<RedemptionStatsSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedemptionStatsSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedemptionStatsSummaryDto>;
        }));
    }

    protected processGetStats(response: HttpResponseBase): Observable<RedemptionStatsSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedemptionStatsSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export redemptions to CSV, for the Order Management grid's "Export CSV" button.
    Same convention as Admin/VoucherController.ExportVouchersToCSV: a naive single-query
    in-memory export (capped at 5,000 rows here, since this is Elasticsearch-backed rather
    than a DynamoDB scan) rather than a Step Function/S3 export - fine for now, revisit if
    advertisers need full-history dumps.
     * @param query (optional) 
     * @return Success
     */
    exportCsv(query: RedemptionQueryDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/reward-redemption/exportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCsv(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsRoutingApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    listRoutingRules(search: string | null | undefined): Observable<RoutingRuleDto[]> {
        let url_ = this.baseUrl + "/api/admin/routing-control?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRoutingRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRoutingRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoutingRuleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoutingRuleDto[]>;
        }));
    }

    protected processListRoutingRules(response: HttpResponseBase): Observable<RoutingRuleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoutingRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    createRoutingRule(request: CreateRoutingRuleRequest | null | undefined): Observable<RoutingRuleDto> {
        let url_ = this.baseUrl + "/api/admin/routing-control";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRoutingRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRoutingRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoutingRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoutingRuleDto>;
        }));
    }

    protected processCreateRoutingRule(response: HttpResponseBase): Observable<RoutingRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RoutingRuleDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoutingRuleByAdvertiserId(advertiserId: string): Observable<RoutingRuleDto> {
        let url_ = this.baseUrl + "/api/admin/routing-control/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoutingRuleByAdvertiserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoutingRuleByAdvertiserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoutingRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoutingRuleDto>;
        }));
    }

    protected processGetRoutingRuleByAdvertiserId(response: HttpResponseBase): Observable<RoutingRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutingRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updateRoutingRule(advertiserId: string, request: UpdateRoutingRuleRequest | null | undefined): Observable<RoutingRuleDto> {
        let url_ = this.baseUrl + "/api/admin/routing-control/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoutingRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoutingRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoutingRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoutingRuleDto>;
        }));
    }

    protected processUpdateRoutingRule(response: HttpResponseBase): Observable<RoutingRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutingRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteRoutingRule(advertiserId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/routing-control/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRoutingRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRoutingRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRoutingRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsSurveyGameApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getByIdCompleted(surveyId: string): Observable<SurveyCompleted> {
        let url_ = this.baseUrl + "/api/admin/survey/completed/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyCompleted>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyCompleted>;
        }));
    }

    protected processGetByIdCompleted(response: HttpResponseBase): Observable<SurveyCompleted> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyCompleted.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByIdsCompleted(surveyId: string, answerId: string): Observable<SurveyGameInfo> {
        let url_ = this.baseUrl + "/api/admin/survey/byIds/completed/{surveyId}/{answerId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (answerId === undefined || answerId === null)
            throw new globalThis.Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdsCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdsCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyGameInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyGameInfo>;
        }));
    }

    protected processGetByIdsCompleted(response: HttpResponseBase): Observable<SurveyGameInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyGameInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param survey (optional) 
     * @return Success
     */
    save(survey: SurveyCompleted | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/save/completed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(survey);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param items (optional) 
     * @return Success
     */
    saveBulk(items: SurveyCompleted[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/saveBulk/completed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteCompleted(surveyId: string, answerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/delete/completed/{surveyId}/{answerId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (answerId === undefined || answerId === null)
            throw new globalThis.Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByIdQuestionnaire(surveyId: string): Observable<SurveyQuestionnaire> {
        let url_ = this.baseUrl + "/api/admin/survey/questionnaire/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionnaire>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionnaire>;
        }));
    }

    protected processGetByIdQuestionnaire(response: HttpResponseBase): Observable<SurveyQuestionnaire> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionnaire.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByIdsQuestionnaire(surveyId: string, answerId: string): Observable<SurveyGameInfo> {
        let url_ = this.baseUrl + "/api/admin/survey/byIds/questionnaire/{surveyId}/{answerId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (answerId === undefined || answerId === null)
            throw new globalThis.Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdsQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdsQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyGameInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyGameInfo>;
        }));
    }

    protected processGetByIdsQuestionnaire(response: HttpResponseBase): Observable<SurveyGameInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyGameInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    querySurveysQuestionnaire(query: SurveyQuery | null | undefined): Observable<SurveyQuestionnaireSurveyQueryResponse> {
        let url_ = this.baseUrl + "/api/admin/survey/query/questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuerySurveysQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuerySurveysQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionnaireSurveyQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionnaireSurveyQueryResponse>;
        }));
    }

    protected processQuerySurveysQuestionnaire(response: HttpResponseBase): Observable<SurveyQuestionnaireSurveyQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionnaireSurveyQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param survey (optional) 
     * @return Success
     */
    saveQuestionnaire(survey: SurveyQuestionnaire | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/save/questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(survey);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveQuestionnaire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param items (optional) 
     * @return Success
     */
    saveBulkQuestionnaire(items: SurveyQuestionnaire[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/saveBulk/questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBulkQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBulkQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveBulkQuestionnaire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteQuestionnaire(surveyId: string, answerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/delete/questionnaire/{surveyId}/{answerId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (answerId === undefined || answerId === null)
            throw new globalThis.Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteQuestionnaire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    exportToCSV(query: SurveyQuery | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/survey/exportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportToCSV(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importFromCSV(file: FileToUpload | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/importFromCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFromCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFromCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportFromCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    updateFromCSV(file: FileToUpload | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/survey/updateFromCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFromCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFromCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFromCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<Language[]> {
        let url_ = this.baseUrl + "/api/admin/survey/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Language[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Language[]>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<Language[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Language.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsVersionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the API version of the device management sub-domain..
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method used to test exception handling.
     * @return Success
     */
    testException(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestException(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test Insights authorization
     * @return Success
     */
    testInsightsAuthorization(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/testInsightsAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestInsightsAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestInsightsAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestInsightsAuthorization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsVoucherApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search vouchers.
     * @param query (optional) 
     * @return Success
     */
    queryVouchers(query: VoucherQuery | null | undefined): Observable<VoucherDTOVoucherQueryResponse> {
        let url_ = this.baseUrl + "/api/admin/voucher/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryVouchers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryVouchers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDTOVoucherQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDTOVoucherQueryResponse>;
        }));
    }

    protected processQueryVouchers(response: HttpResponseBase): Observable<VoucherDTOVoucherQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDTOVoucherQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get voucher by id.
     * @return Success
     */
    getVoucherById(id: number): Observable<VoucherDTO> {
        let url_ = this.baseUrl + "/api/admin/voucher/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDTO>;
        }));
    }

    protected processGetVoucherById(response: HttpResponseBase): Observable<VoucherDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export vouchers to CSV
     * @param query (optional) 
     * @return Success
     */
    exportVouchersToCSV(query: VoucherQuery | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/voucher/exportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVouchersToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVouchersToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportVouchersToCSV(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import vouchers from CSV
     * @param importVoucher (optional) 
     * @return Success
     */
    importVouchersFromCSV(importVoucher: ImportVoucherFromCsv | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/voucher/importFromCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importVoucher);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportVouchersFromCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportVouchersFromCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportVouchersFromCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update vouchers from CSV
     * @param file (optional) 
     * @return Success
     */
    updateVouchersFromCSV(file: FileToUpload | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/voucher/updateFromCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVouchersFromCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVouchersFromCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateVouchersFromCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUploadUrlS3(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/voucher/getUploadUrlS3/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadUrlS3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadUrlS3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUploadUrlS3(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param errorMessage (optional) 
     * @param importVoucher (optional) 
     * @return Success
     */
    sendMailError(errorMessage: string | null | undefined, importVoucher: ImportVoucherFromCsv | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/voucher/sendMailError?";
        if (errorMessage !== undefined && errorMessage !== null)
            url_ += "errorMessage=" + encodeURIComponent("" + errorMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importVoucher);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create voucher.
     * @param request (optional) 
     * @return Success
     */
    createVoucher(request: VoucherDTO | null | undefined): Observable<VoucherDTO> {
        let url_ = this.baseUrl + "/api/admin/voucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDTO>;
        }));
    }

    protected processCreateVoucher(response: HttpResponseBase): Observable<VoucherDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RewardsVoucherPoolApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REWARDS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search vouchers in the pool.
     * @param query (optional) 
     * @return Success
     */
    queryVoucherPools(query: VoucherPoolQuery | null | undefined): Observable<VoucherPoolDTOVoucherPoolQueryResponse> {
        let url_ = this.baseUrl + "/api/admin/voucherpool/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryVoucherPools(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryVoucherPools(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherPoolDTOVoucherPoolQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherPoolDTOVoucherPoolQueryResponse>;
        }));
    }

    protected processQueryVoucherPools(response: HttpResponseBase): Observable<VoucherPoolDTOVoucherPoolQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherPoolDTOVoucherPoolQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a pool voucher by id.
     * @return Success
     */
    getVoucherPoolById(id: string): Observable<VoucherPoolDTO> {
        let url_ = this.baseUrl + "/api/admin/voucherpool/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherPoolById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherPoolById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherPoolDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherPoolDTO>;
        }));
    }

    protected processGetVoucherPoolById(response: HttpResponseBase): Observable<VoucherPoolDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherPoolDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export pool vouchers to CSV.
     * @param query (optional) 
     * @return Success
     */
    exportVoucherPoolsToCSV(query: VoucherPoolQuery | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/voucherpool/exportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVoucherPoolsToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoucherPoolsToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportVoucherPoolsToCSV(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk-load unallocated vouchers into the pool from a CSV file (RewardId,Code1,Code1Label,Code1UrlText,Code2,Code2Label,Code2UrlText,ExpirationDate).
     * @param file (optional) 
     * @return Success
     */
    importVoucherPoolsFromCSV(file: FileToUpload | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/voucherpool/importFromCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportVoucherPoolsFromCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportVoucherPoolsFromCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportVoucherPoolsFromCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminRedemptionActionRequest implements IAdminRedemptionActionRequest {
    staffId?: string | undefined;

    constructor(data?: IAdminRedemptionActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffId = _data["staffId"];
        }
    }

    static fromJS(data: any): AdminRedemptionActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRedemptionActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        return data;
    }
}

export interface IAdminRedemptionActionRequest {
    staffId?: string | undefined;
}

export class AdvertiserSummaryDto implements IAdvertiserSummaryDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;

    constructor(data?: IAdvertiserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
        }
    }

    static fromJS(data: any): AdvertiserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        return data;
    }
}

export interface IAdvertiserSummaryDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
}

export enum AudienceType {
    Consumer = "Consumer",
    Staff = "Staff",
}

export class CompleteOrderRequest implements ICompleteOrderRequest {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    staffId?: string | undefined;

    constructor(data?: ICompleteOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderKey = _data["orderKey"];
            this.staffId = _data["staffId"];
        }
    }

    static fromJS(data: any): CompleteOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderKey"] = this.orderKey;
        data["staffId"] = this.staffId;
        return data;
    }
}

export interface ICompleteOrderRequest {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    staffId?: string | undefined;
}

/** Create order parameters */
export class CreateOrderRequest implements ICreateOrderRequest {
    /** Product id */
    productId?: string | undefined;
    /** The user that will receive the product */
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    countryCode?: string | undefined;
    userCpf?: string | undefined;
    phoneNo?: string | undefined;
    advertiserId?: string | undefined;
    isStaff?: boolean | undefined;

    constructor(data?: ICreateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.countryCode = _data["countryCode"];
            this.userCpf = _data["userCpf"];
            this.phoneNo = _data["phoneNo"];
            this.advertiserId = _data["advertiserId"];
            this.isStaff = _data["isStaff"];
        }
    }

    static fromJS(data: any): CreateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["email"] = this.email;
        data["countryCode"] = this.countryCode;
        data["userCpf"] = this.userCpf;
        data["phoneNo"] = this.phoneNo;
        data["advertiserId"] = this.advertiserId;
        data["isStaff"] = this.isStaff;
        return data;
    }
}

/** Create order parameters */
export interface ICreateOrderRequest {
    /** Product id */
    productId?: string | undefined;
    /** The user that will receive the product */
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    countryCode?: string | undefined;
    userCpf?: string | undefined;
    phoneNo?: string | undefined;
    advertiserId?: string | undefined;
    isStaff?: boolean | undefined;
}

export class CreateProductRequest implements ICreateProductRequest {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    productName?: string | undefined;
    productSlug?: string | undefined;
    productDescription?: string | undefined;
    productPhotoUrl?: string | undefined;
    categorySlug?: string | undefined;
    categoryDescription?: string | undefined;
    categoryName?: string | undefined;
    virtual?: boolean | undefined;
    attributes?: ProductAttributeLine[] | undefined;

    constructor(data?: ICreateProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.productName = _data["productName"];
            this.productSlug = _data["productSlug"];
            this.productDescription = _data["productDescription"];
            this.productPhotoUrl = _data["productPhotoUrl"];
            this.categorySlug = _data["categorySlug"];
            this.categoryDescription = _data["categoryDescription"];
            this.categoryName = _data["categoryName"];
            this.virtual = _data["virtual"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ProductAttributeLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["productName"] = this.productName;
        data["productSlug"] = this.productSlug;
        data["productDescription"] = this.productDescription;
        data["productPhotoUrl"] = this.productPhotoUrl;
        data["categorySlug"] = this.categorySlug;
        data["categoryDescription"] = this.categoryDescription;
        data["categoryName"] = this.categoryName;
        data["virtual"] = this.virtual;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateProductRequest {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    productName?: string | undefined;
    productSlug?: string | undefined;
    productDescription?: string | undefined;
    productPhotoUrl?: string | undefined;
    categorySlug?: string | undefined;
    categoryDescription?: string | undefined;
    categoryName?: string | undefined;
    virtual?: boolean | undefined;
    attributes?: ProductAttributeLine[] | undefined;
}

export class CreateRewardDefinitionRequest implements ICreateRewardDefinitionRequest {
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    customAttributes?: { [key: string]: string; } | undefined;

    constructor(data?: ICreateRewardDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.rewardType = _data["rewardType"];
            this.price = _data["price"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["advertisers"])) {
                this.advertisers = [] as any;
                for (let item of _data["advertisers"])
                    this.advertisers!.push(RewardAdvertiserDto.fromJS(item));
            }
            this.audienceType = _data["audienceType"];
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.isPopular = _data["isPopular"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            if (_data["customAttributes"]) {
                this.customAttributes = {} as any;
                for (let key in _data["customAttributes"]) {
                    if (_data["customAttributes"].hasOwnProperty(key))
                        (this.customAttributes as any)![key] = _data["customAttributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateRewardDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRewardDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["rewardType"] = this.rewardType;
        data["price"] = this.price;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.advertisers)) {
            data["advertisers"] = [];
            for (let item of this.advertisers)
                data["advertisers"].push(item ? item.toJSON() : undefined as any);
        }
        data["audienceType"] = this.audienceType;
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["isPopular"] = this.isPopular;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        if (this.customAttributes) {
            data["customAttributes"] = {};
            for (let key in this.customAttributes) {
                if (this.customAttributes.hasOwnProperty(key))
                    (data["customAttributes"] as any)[key] = (this.customAttributes as any)[key];
            }
        }
        return data;
    }
}

export interface ICreateRewardDefinitionRequest {
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
}

export class CreateRoutingRuleRequest implements ICreateRoutingRuleRequest {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    provider?: string | undefined;

    constructor(data?: ICreateRoutingRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): CreateRoutingRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoutingRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ICreateRoutingRuleRequest {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    provider?: string | undefined;
}

export class CreateSimpleOrderRequest implements ICreateSimpleOrderRequest {
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    userPhone?: string | undefined;
    userCountryCode?: string | undefined;
    productId?: string | undefined;
    productSlug?: string | undefined;
    productName?: string | undefined;
    productPhotoUrl?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    categoryDescription?: string | undefined;
    giveRewardCode?: boolean | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    campaignId?: string | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    gpsCoordinates?: GpsCoordinates | undefined;
    isStaffReward?: boolean | undefined;

    constructor(data?: ICreateSimpleOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.userCountryCode = _data["userCountryCode"];
            this.productId = _data["productId"];
            this.productSlug = _data["productSlug"];
            this.productName = _data["productName"];
            this.productPhotoUrl = _data["productPhotoUrl"];
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.categoryDescription = _data["categoryDescription"];
            this.giveRewardCode = _data["giveRewardCode"];
            this.vendorId = _data["vendorId"];
            this.vendorName = _data["vendorName"];
            this.campaignId = _data["campaignId"];
            this.campaignStartDate = _data["campaignStartDate"] ? new Date(_data["campaignStartDate"].toString()) : undefined as any;
            this.campaignEndDate = _data["campaignEndDate"] ? new Date(_data["campaignEndDate"].toString()) : undefined as any;
            this.gpsCoordinates = _data["gpsCoordinates"] ? GpsCoordinates.fromJS(_data["gpsCoordinates"]) : undefined as any;
            this.isStaffReward = _data["isStaffReward"];
        }
    }

    static fromJS(data: any): CreateSimpleOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSimpleOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["userCountryCode"] = this.userCountryCode;
        data["productId"] = this.productId;
        data["productSlug"] = this.productSlug;
        data["productName"] = this.productName;
        data["productPhotoUrl"] = this.productPhotoUrl;
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["categoryDescription"] = this.categoryDescription;
        data["giveRewardCode"] = this.giveRewardCode;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["campaignId"] = this.campaignId;
        data["campaignStartDate"] = this.campaignStartDate ? this.campaignStartDate.toISOString() : undefined as any;
        data["campaignEndDate"] = this.campaignEndDate ? this.campaignEndDate.toISOString() : undefined as any;
        data["gpsCoordinates"] = this.gpsCoordinates ? this.gpsCoordinates.toJSON() : undefined as any;
        data["isStaffReward"] = this.isStaffReward;
        return data;
    }
}

export interface ICreateSimpleOrderRequest {
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    userPhone?: string | undefined;
    userCountryCode?: string | undefined;
    productId?: string | undefined;
    productSlug?: string | undefined;
    productName?: string | undefined;
    productPhotoUrl?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    categoryDescription?: string | undefined;
    giveRewardCode?: boolean | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    campaignId?: string | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    gpsCoordinates?: GpsCoordinates | undefined;
    isStaffReward?: boolean | undefined;
}

export class FileToUpload implements IFileToUpload {
    fileName?: string | undefined;
    fileSize?: number | undefined;
    fileType?: string | undefined;
    fileAsBase64?: string | undefined;
    readonly fileAsByteArray?: string | undefined;

    constructor(data?: IFileToUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.fileAsBase64 = _data["fileAsBase64"];
            (this as any).fileAsByteArray = _data["fileAsByteArray"];
        }
    }

    static fromJS(data: any): FileToUpload {
        data = typeof data === 'object' ? data : {};
        let result = new FileToUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["fileAsBase64"] = this.fileAsBase64;
        data["fileAsByteArray"] = this.fileAsByteArray;
        return data;
    }
}

export interface IFileToUpload {
    fileName?: string | undefined;
    fileSize?: number | undefined;
    fileType?: string | undefined;
    fileAsBase64?: string | undefined;
    fileAsByteArray?: string | undefined;
}

export class Game implements IGame {
    id?: string | undefined;
    encryptionKey?: string | undefined;
    algorithm?: string | undefined;
    gameUrl?: string | undefined;
    gameSlug?: string | undefined;
    cardId?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    userName?: string | undefined;
    userCountryCode?: string | undefined;
    userPhone?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    ipAddress?: string | undefined;
    chances?: GameChance[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
    orderIdsRewarded?: string[] | undefined;
    orderRewards?: RewardInfo[] | undefined;
    customization?: GameCustomization | undefined;
    campaignId?: string | undefined;
    isSaveGameResult?: boolean | undefined;

    constructor(data?: IGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.encryptionKey = _data["encryptionKey"];
            this.algorithm = _data["algorithm"];
            this.gameUrl = _data["gameUrl"];
            this.gameSlug = _data["gameSlug"];
            this.cardId = _data["cardId"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.userName = _data["userName"];
            this.userCountryCode = _data["userCountryCode"];
            this.userPhone = _data["userPhone"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.ipAddress = _data["ipAddress"];
            if (Array.isArray(_data["chances"])) {
                this.chances = [] as any;
                for (let item of _data["chances"])
                    this.chances!.push(GameChance.fromJS(item));
            }
            this.calculateWinningChanceServerside = _data["calculateWinningChanceServerside"];
            if (Array.isArray(_data["orderIdsRewarded"])) {
                this.orderIdsRewarded = [] as any;
                for (let item of _data["orderIdsRewarded"])
                    this.orderIdsRewarded!.push(item);
            }
            if (Array.isArray(_data["orderRewards"])) {
                this.orderRewards = [] as any;
                for (let item of _data["orderRewards"])
                    this.orderRewards!.push(RewardInfo.fromJS(item));
            }
            this.customization = _data["customization"] ? GameCustomization.fromJS(_data["customization"]) : undefined as any;
            this.campaignId = _data["campaignId"];
            this.isSaveGameResult = _data["isSaveGameResult"];
        }
    }

    static fromJS(data: any): Game {
        data = typeof data === 'object' ? data : {};
        let result = new Game();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["encryptionKey"] = this.encryptionKey;
        data["algorithm"] = this.algorithm;
        data["gameUrl"] = this.gameUrl;
        data["gameSlug"] = this.gameSlug;
        data["cardId"] = this.cardId;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["userName"] = this.userName;
        data["userCountryCode"] = this.userCountryCode;
        data["userPhone"] = this.userPhone;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["ipAddress"] = this.ipAddress;
        if (Array.isArray(this.chances)) {
            data["chances"] = [];
            for (let item of this.chances)
                data["chances"].push(item ? item.toJSON() : undefined as any);
        }
        data["calculateWinningChanceServerside"] = this.calculateWinningChanceServerside;
        if (Array.isArray(this.orderIdsRewarded)) {
            data["orderIdsRewarded"] = [];
            for (let item of this.orderIdsRewarded)
                data["orderIdsRewarded"].push(item);
        }
        if (Array.isArray(this.orderRewards)) {
            data["orderRewards"] = [];
            for (let item of this.orderRewards)
                data["orderRewards"].push(item ? item.toJSON() : undefined as any);
        }
        data["customization"] = this.customization ? this.customization.toJSON() : undefined as any;
        data["campaignId"] = this.campaignId;
        data["isSaveGameResult"] = this.isSaveGameResult;
        return data;
    }
}

export interface IGame {
    id?: string | undefined;
    encryptionKey?: string | undefined;
    algorithm?: string | undefined;
    gameUrl?: string | undefined;
    gameSlug?: string | undefined;
    cardId?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    userName?: string | undefined;
    userCountryCode?: string | undefined;
    userPhone?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    ipAddress?: string | undefined;
    chances?: GameChance[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
    orderIdsRewarded?: string[] | undefined;
    orderRewards?: RewardInfo[] | undefined;
    customization?: GameCustomization | undefined;
    campaignId?: string | undefined;
    isSaveGameResult?: boolean | undefined;
}

export class GameChance implements IGameChance {
    chance?: number | undefined;
    product?: ProductInfo | undefined;

    constructor(data?: IGameChance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chance = _data["chance"];
            this.product = _data["product"] ? ProductInfo.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): GameChance {
        data = typeof data === 'object' ? data : {};
        let result = new GameChance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chance"] = this.chance;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface IGameChance {
    chance?: number | undefined;
    product?: ProductInfo | undefined;
}

export class GameCustomization implements IGameCustomization {
    animationUrl?: string | undefined;
    coverUrl?: string | undefined;
    backgroundUrl?: string | undefined;
    fontUrl?: string | undefined;
    brandStyle?: string | undefined;

    constructor(data?: IGameCustomization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animationUrl = _data["animationUrl"];
            this.coverUrl = _data["coverUrl"];
            this.backgroundUrl = _data["backgroundUrl"];
            this.fontUrl = _data["fontUrl"];
            this.brandStyle = _data["brandStyle"];
        }
    }

    static fromJS(data: any): GameCustomization {
        data = typeof data === 'object' ? data : {};
        let result = new GameCustomization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animationUrl"] = this.animationUrl;
        data["coverUrl"] = this.coverUrl;
        data["backgroundUrl"] = this.backgroundUrl;
        data["fontUrl"] = this.fontUrl;
        data["brandStyle"] = this.brandStyle;
        return data;
    }
}

export interface IGameCustomization {
    animationUrl?: string | undefined;
    coverUrl?: string | undefined;
    backgroundUrl?: string | undefined;
    fontUrl?: string | undefined;
    brandStyle?: string | undefined;
}

export class GpsCoordinates implements IGpsCoordinates {
    lat?: number | undefined;
    lng?: number | undefined;

    constructor(data?: IGpsCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): GpsCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new GpsCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface IGpsCoordinates {
    lat?: number | undefined;
    lng?: number | undefined;
}

export class ImportVoucherFromCsv implements IImportVoucherFromCsv {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    email?: string | undefined;
    voucherS3Link?: string | undefined;

    constructor(data?: IImportVoucherFromCsv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.uploadKey = _data["uploadKey"];
            this.isSuccess = _data["isSuccess"];
            this.totalStepElapsedSeconds = _data["totalStepElapsedSeconds"];
            this.nextStep = _data["nextStep"];
            this.email = _data["email"];
            this.voucherS3Link = _data["voucherS3Link"];
        }
    }

    static fromJS(data: any): ImportVoucherFromCsv {
        data = typeof data === 'object' ? data : {};
        let result = new ImportVoucherFromCsv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["uploadKey"] = this.uploadKey;
        data["isSuccess"] = this.isSuccess;
        data["totalStepElapsedSeconds"] = this.totalStepElapsedSeconds;
        data["nextStep"] = this.nextStep;
        data["email"] = this.email;
        data["voucherS3Link"] = this.voucherS3Link;
        return data;
    }
}

export interface IImportVoucherFromCsv {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    email?: string | undefined;
    voucherS3Link?: string | undefined;
}

export class Language implements ILanguage {
    name?: string | undefined;
    twoLetterName?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.twoLetterName = _data["twoLetterName"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["twoLetterName"] = this.twoLetterName;
        return data;
    }
}

export interface ILanguage {
    name?: string | undefined;
    twoLetterName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProductAttributeLine implements IProductAttributeLine {
    id?: number | undefined;
    name?: string | undefined;
    position?: number | undefined;
    visible?: boolean | undefined;
    variation?: boolean | undefined;
    options?: string[] | undefined;

    constructor(data?: IProductAttributeLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.position = _data["position"];
            this.visible = _data["visible"];
            this.variation = _data["variation"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductAttributeLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["position"] = this.position;
        data["visible"] = this.visible;
        data["variation"] = this.variation;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface IProductAttributeLine {
    id?: number | undefined;
    name?: string | undefined;
    position?: number | undefined;
    visible?: boolean | undefined;
    variation?: boolean | undefined;
    options?: string[] | undefined;
}

export class ProductInfo implements IProductInfo {
    id?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    price?: number | undefined;
    endDate?: Date | undefined;
    isPopular?: boolean | undefined;
    advertiserId?: string | undefined;
    isStaffReward?: boolean | undefined;
    doNotCreateDummyVoucher?: boolean | undefined;
    metaData?: ProductMeta[] | undefined;
    rewardId?: string | undefined;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.isVoucher = _data["isVoucher"];
            this.price = _data["price"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.isPopular = _data["isPopular"];
            this.advertiserId = _data["advertiserId"];
            this.isStaffReward = _data["isStaffReward"];
            this.doNotCreateDummyVoucher = _data["doNotCreateDummyVoucher"];
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(ProductMeta.fromJS(item));
            }
            this.rewardId = _data["rewardId"];
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["isVoucher"] = this.isVoucher;
        data["price"] = this.price;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isPopular"] = this.isPopular;
        data["advertiserId"] = this.advertiserId;
        data["isStaffReward"] = this.isStaffReward;
        data["doNotCreateDummyVoucher"] = this.doNotCreateDummyVoucher;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item ? item.toJSON() : undefined as any);
        }
        data["rewardId"] = this.rewardId;
        return data;
    }
}

export interface IProductInfo {
    id?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    price?: number | undefined;
    endDate?: Date | undefined;
    isPopular?: boolean | undefined;
    advertiserId?: string | undefined;
    isStaffReward?: boolean | undefined;
    doNotCreateDummyVoucher?: boolean | undefined;
    metaData?: ProductMeta[] | undefined;
    rewardId?: string | undefined;
}

export class ProductMeta implements IProductMeta {
    id?: number | undefined;
    key?: string | undefined;
    value?: any | undefined;

    constructor(data?: IProductMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IProductMeta {
    id?: number | undefined;
    key?: string | undefined;
    value?: any | undefined;
}

export class RedemptionDailyCountDto implements IRedemptionDailyCountDto {
    date?: string | undefined;
    count?: number | undefined;

    constructor(data?: IRedemptionDailyCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RedemptionDailyCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionDailyCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["count"] = this.count;
        return data;
    }
}

export interface IRedemptionDailyCountDto {
    date?: string | undefined;
    count?: number | undefined;
}

export class RedemptionDto implements IRedemptionDto {
    redemptionId?: string | undefined;
    redemptionKey?: string | undefined;
    rewardId?: string | undefined;
    rewardSlug?: string | undefined;
    rewardType?: string | undefined;
    rewardName?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardPrice?: number | undefined;
    status?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    userPhone?: string | undefined;
    userCountryCode?: string | undefined;
    campaignId?: string | undefined;
    campaignEndDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    isStaffReward?: boolean | undefined;
    staffId?: string | undefined;
    completedAt?: Date | undefined;
    voucherId?: string | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherExpirationDate?: Date | undefined;
    voucherIsDummy?: boolean | undefined;
    gpsLat?: number | undefined;
    gpsLng?: number | undefined;
    cashbackTransactionId?: string | undefined;
    coinJournalEntryId?: string | undefined;
    wooProductId?: number | undefined;
    source?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IRedemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redemptionId = _data["redemptionId"];
            this.redemptionKey = _data["redemptionKey"];
            this.rewardId = _data["rewardId"];
            this.rewardSlug = _data["rewardSlug"];
            this.rewardType = _data["rewardType"];
            this.rewardName = _data["rewardName"];
            this.rewardPhotoUrl = _data["rewardPhotoUrl"];
            this.rewardPrice = _data["rewardPrice"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.userCountryCode = _data["userCountryCode"];
            this.campaignId = _data["campaignId"];
            this.campaignEndDate = _data["campaignEndDate"] ? new Date(_data["campaignEndDate"].toString()) : undefined as any;
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.isStaffReward = _data["isStaffReward"];
            this.staffId = _data["staffId"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.voucherId = _data["voucherId"];
            this.voucherCode1 = _data["voucherCode1"];
            this.voucherCode1Label = _data["voucherCode1Label"];
            this.voucherCode2 = _data["voucherCode2"];
            this.voucherCode2Label = _data["voucherCode2Label"];
            this.voucherExpirationDate = _data["voucherExpirationDate"] ? new Date(_data["voucherExpirationDate"].toString()) : undefined as any;
            this.voucherIsDummy = _data["voucherIsDummy"];
            this.gpsLat = _data["gpsLat"];
            this.gpsLng = _data["gpsLng"];
            this.cashbackTransactionId = _data["cashbackTransactionId"];
            this.coinJournalEntryId = _data["coinJournalEntryId"];
            this.wooProductId = _data["wooProductId"];
            this.source = _data["source"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RedemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redemptionId"] = this.redemptionId;
        data["redemptionKey"] = this.redemptionKey;
        data["rewardId"] = this.rewardId;
        data["rewardSlug"] = this.rewardSlug;
        data["rewardType"] = this.rewardType;
        data["rewardName"] = this.rewardName;
        data["rewardPhotoUrl"] = this.rewardPhotoUrl;
        data["rewardPrice"] = this.rewardPrice;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["userCountryCode"] = this.userCountryCode;
        data["campaignId"] = this.campaignId;
        data["campaignEndDate"] = this.campaignEndDate ? this.campaignEndDate.toISOString() : undefined as any;
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["isStaffReward"] = this.isStaffReward;
        data["staffId"] = this.staffId;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["voucherId"] = this.voucherId;
        data["voucherCode1"] = this.voucherCode1;
        data["voucherCode1Label"] = this.voucherCode1Label;
        data["voucherCode2"] = this.voucherCode2;
        data["voucherCode2Label"] = this.voucherCode2Label;
        data["voucherExpirationDate"] = this.voucherExpirationDate ? this.voucherExpirationDate.toISOString() : undefined as any;
        data["voucherIsDummy"] = this.voucherIsDummy;
        data["gpsLat"] = this.gpsLat;
        data["gpsLng"] = this.gpsLng;
        data["cashbackTransactionId"] = this.cashbackTransactionId;
        data["coinJournalEntryId"] = this.coinJournalEntryId;
        data["wooProductId"] = this.wooProductId;
        data["source"] = this.source;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRedemptionDto {
    redemptionId?: string | undefined;
    redemptionKey?: string | undefined;
    rewardId?: string | undefined;
    rewardSlug?: string | undefined;
    rewardType?: string | undefined;
    rewardName?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardPrice?: number | undefined;
    status?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    userPhone?: string | undefined;
    userCountryCode?: string | undefined;
    campaignId?: string | undefined;
    campaignEndDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    isStaffReward?: boolean | undefined;
    staffId?: string | undefined;
    completedAt?: Date | undefined;
    voucherId?: string | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherExpirationDate?: Date | undefined;
    voucherIsDummy?: boolean | undefined;
    gpsLat?: number | undefined;
    gpsLng?: number | undefined;
    cashbackTransactionId?: string | undefined;
    coinJournalEntryId?: string | undefined;
    wooProductId?: number | undefined;
    source?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export class RedemptionQueryDto implements IRedemptionQueryDto {
    search?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    rewardId?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;

    constructor(data?: IRedemptionQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.advertiserId = _data["advertiserId"];
            this.campaignId = _data["campaignId"];
            this.rewardId = _data["rewardId"];
            this.status = _data["status"];
            this.rewardType = _data["rewardType"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
        }
    }

    static fromJS(data: any): RedemptionQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["advertiserId"] = this.advertiserId;
        data["campaignId"] = this.campaignId;
        data["rewardId"] = this.rewardId;
        data["status"] = this.status;
        data["rewardType"] = this.rewardType;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        return data;
    }
}

export interface IRedemptionQueryDto {
    search?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    rewardId?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
}

export class RedemptionSearchResponseDto implements IRedemptionSearchResponseDto {
    items?: RedemptionDto[] | undefined;
    total?: number | undefined;

    constructor(data?: IRedemptionSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RedemptionDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): RedemptionSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IRedemptionSearchResponseDto {
    items?: RedemptionDto[] | undefined;
    total?: number | undefined;
}

export class RedemptionStatsQueryDto implements IRedemptionStatsQueryDto {
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IRedemptionStatsQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.campaignId = _data["campaignId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RedemptionStatsQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionStatsQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["campaignId"] = this.campaignId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        return data;
    }
}

export interface IRedemptionStatsQueryDto {
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export class RedemptionStatsSummaryDto implements IRedemptionStatsSummaryDto {
    totalRedemptions?: number | undefined;
    successRate?: number | undefined;
    byRewardType?: { [key: string]: number; } | undefined;
    byStatus?: { [key: string]: number; } | undefined;
    dailySeries?: RedemptionDailyCountDto[] | undefined;

    constructor(data?: IRedemptionStatsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRedemptions = _data["totalRedemptions"];
            this.successRate = _data["successRate"];
            if (_data["byRewardType"]) {
                this.byRewardType = {} as any;
                for (let key in _data["byRewardType"]) {
                    if (_data["byRewardType"].hasOwnProperty(key))
                        (this.byRewardType as any)![key] = _data["byRewardType"][key];
                }
            }
            if (_data["byStatus"]) {
                this.byStatus = {} as any;
                for (let key in _data["byStatus"]) {
                    if (_data["byStatus"].hasOwnProperty(key))
                        (this.byStatus as any)![key] = _data["byStatus"][key];
                }
            }
            if (Array.isArray(_data["dailySeries"])) {
                this.dailySeries = [] as any;
                for (let item of _data["dailySeries"])
                    this.dailySeries!.push(RedemptionDailyCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RedemptionStatsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionStatsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRedemptions"] = this.totalRedemptions;
        data["successRate"] = this.successRate;
        if (this.byRewardType) {
            data["byRewardType"] = {};
            for (let key in this.byRewardType) {
                if (this.byRewardType.hasOwnProperty(key))
                    (data["byRewardType"] as any)[key] = (this.byRewardType as any)[key];
            }
        }
        if (this.byStatus) {
            data["byStatus"] = {};
            for (let key in this.byStatus) {
                if (this.byStatus.hasOwnProperty(key))
                    (data["byStatus"] as any)[key] = (this.byStatus as any)[key];
            }
        }
        if (Array.isArray(this.dailySeries)) {
            data["dailySeries"] = [];
            for (let item of this.dailySeries)
                data["dailySeries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRedemptionStatsSummaryDto {
    totalRedemptions?: number | undefined;
    successRate?: number | undefined;
    byRewardType?: { [key: string]: number; } | undefined;
    byStatus?: { [key: string]: number; } | undefined;
    dailySeries?: RedemptionDailyCountDto[] | undefined;
}

export class RewardAdvertiserDto implements IRewardAdvertiserDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;

    constructor(data?: IRewardAdvertiserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
        }
    }

    static fromJS(data: any): RewardAdvertiserDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardAdvertiserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        return data;
    }
}

export interface IRewardAdvertiserDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
}

export class RewardCatalogQueryDto implements IRewardCatalogQueryDto {
    search?: string | undefined;
    advertiserId?: string | undefined;
    categorySlug?: string | undefined;
    countryCode?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    audienceType?: string | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;

    constructor(data?: IRewardCatalogQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.advertiserId = _data["advertiserId"];
            this.categorySlug = _data["categorySlug"];
            this.countryCode = _data["countryCode"];
            this.status = _data["status"];
            this.rewardType = _data["rewardType"];
            this.audienceType = _data["audienceType"];
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
        }
    }

    static fromJS(data: any): RewardCatalogQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardCatalogQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["advertiserId"] = this.advertiserId;
        data["categorySlug"] = this.categorySlug;
        data["countryCode"] = this.countryCode;
        data["status"] = this.status;
        data["rewardType"] = this.rewardType;
        data["audienceType"] = this.audienceType;
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        return data;
    }
}

export interface IRewardCatalogQueryDto {
    search?: string | undefined;
    advertiserId?: string | undefined;
    categorySlug?: string | undefined;
    countryCode?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    audienceType?: string | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
}

export class RewardCatalogSearchResponseDto implements IRewardCatalogSearchResponseDto {
    items?: RewardDefinitionDto[] | undefined;
    total?: number | undefined;

    constructor(data?: IRewardCatalogSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RewardDefinitionDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): RewardCatalogSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardCatalogSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IRewardCatalogSearchResponseDto {
    items?: RewardDefinitionDto[] | undefined;
    total?: number | undefined;
}

export class RewardCategorySummaryDto implements IRewardCategorySummaryDto {
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    rewardCount?: number | undefined;

    constructor(data?: IRewardCategorySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.rewardCount = _data["rewardCount"];
        }
    }

    static fromJS(data: any): RewardCategorySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardCategorySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["rewardCount"] = this.rewardCount;
        return data;
    }
}

export interface IRewardCategorySummaryDto {
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    rewardCount?: number | undefined;
}

export class RewardDefinitionDto implements IRewardDefinitionDto {
    rewardId?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    customAttributes?: { [key: string]: string; } | undefined;

    constructor(data?: IRewardDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rewardId = _data["rewardId"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.status = _data["status"];
            this.rewardType = _data["rewardType"];
            this.price = _data["price"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["advertisers"])) {
                this.advertisers = [] as any;
                for (let item of _data["advertisers"])
                    this.advertisers!.push(RewardAdvertiserDto.fromJS(item));
            }
            this.audienceType = _data["audienceType"];
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.isPopular = _data["isPopular"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            if (_data["customAttributes"]) {
                this.customAttributes = {} as any;
                for (let key in _data["customAttributes"]) {
                    if (_data["customAttributes"].hasOwnProperty(key))
                        (this.customAttributes as any)![key] = _data["customAttributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): RewardDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["status"] = this.status;
        data["rewardType"] = this.rewardType;
        data["price"] = this.price;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.advertisers)) {
            data["advertisers"] = [];
            for (let item of this.advertisers)
                data["advertisers"].push(item ? item.toJSON() : undefined as any);
        }
        data["audienceType"] = this.audienceType;
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["isPopular"] = this.isPopular;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        if (this.customAttributes) {
            data["customAttributes"] = {};
            for (let key in this.customAttributes) {
                if (this.customAttributes.hasOwnProperty(key))
                    (data["customAttributes"] as any)[key] = (this.customAttributes as any)[key];
            }
        }
        return data;
    }
}

export interface IRewardDefinitionDto {
    rewardId?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    status?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
}

export class RewardInfo implements IRewardInfo {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    redeemDate?: Date | undefined;
    isUsed?: boolean | undefined;
    isOnHold?: boolean | undefined;
    isStaffReward?: boolean | undefined;
    title?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode1UrlText?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherCode2UrlText?: string | undefined;
    activityTitle?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    isGame?: boolean | undefined;
    gameUrl?: string | undefined;
    rewardId?: string | undefined;
    rewardName?: string | undefined;
    campaignId?: string | undefined;
    endDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    organizationLocations?: number | undefined;
    customerId?: string | undefined;
    completedBy?: string | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IRewardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderKey = _data["orderKey"];
            this.redeemDate = _data["redeemDate"] ? new Date(_data["redeemDate"].toString()) : undefined as any;
            this.isUsed = _data["isUsed"];
            this.isOnHold = _data["isOnHold"];
            this.isStaffReward = _data["isStaffReward"];
            this.title = _data["title"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.isVoucher = _data["isVoucher"];
            this.voucherCode1 = _data["voucherCode1"];
            this.voucherCode1Label = _data["voucherCode1Label"];
            this.voucherCode1UrlText = _data["voucherCode1UrlText"];
            this.voucherCode2 = _data["voucherCode2"];
            this.voucherCode2Label = _data["voucherCode2Label"];
            this.voucherCode2UrlText = _data["voucherCode2UrlText"];
            this.activityTitle = _data["activityTitle"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.isGame = _data["isGame"];
            this.gameUrl = _data["gameUrl"];
            this.rewardId = _data["rewardId"];
            this.rewardName = _data["rewardName"];
            this.campaignId = _data["campaignId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.organizationLocations = _data["organizationLocations"];
            this.customerId = _data["customerId"];
            this.completedBy = _data["completedBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RewardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RewardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderKey"] = this.orderKey;
        data["redeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : undefined as any;
        data["isUsed"] = this.isUsed;
        data["isOnHold"] = this.isOnHold;
        data["isStaffReward"] = this.isStaffReward;
        data["title"] = this.title;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["isVoucher"] = this.isVoucher;
        data["voucherCode1"] = this.voucherCode1;
        data["voucherCode1Label"] = this.voucherCode1Label;
        data["voucherCode1UrlText"] = this.voucherCode1UrlText;
        data["voucherCode2"] = this.voucherCode2;
        data["voucherCode2Label"] = this.voucherCode2Label;
        data["voucherCode2UrlText"] = this.voucherCode2UrlText;
        data["activityTitle"] = this.activityTitle;
        data["description"] = this.description;
        data["price"] = this.price;
        data["isGame"] = this.isGame;
        data["gameUrl"] = this.gameUrl;
        data["rewardId"] = this.rewardId;
        data["rewardName"] = this.rewardName;
        data["campaignId"] = this.campaignId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["organizationLocations"] = this.organizationLocations;
        data["customerId"] = this.customerId;
        data["completedBy"] = this.completedBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRewardInfo {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    redeemDate?: Date | undefined;
    isUsed?: boolean | undefined;
    isOnHold?: boolean | undefined;
    isStaffReward?: boolean | undefined;
    title?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode1UrlText?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherCode2UrlText?: string | undefined;
    activityTitle?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    isGame?: boolean | undefined;
    gameUrl?: string | undefined;
    rewardId?: string | undefined;
    rewardName?: string | undefined;
    campaignId?: string | undefined;
    endDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    organizationLocations?: number | undefined;
    customerId?: string | undefined;
    completedBy?: string | undefined;
    createdAt?: Date | undefined;
}

export class RoutingRuleDto implements IRoutingRuleDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    provider?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IRoutingRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.provider = _data["provider"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RoutingRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoutingRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["provider"] = this.provider;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRoutingRuleDto {
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    provider?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export class StartGame implements IStartGame {
    encryptionKey?: string | undefined;
    chances?: GameChance[] | undefined;
    survey?: SurveyQuestionnaire | undefined;
    vouchersOutOfStock?: ProductInfo[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;

    constructor(data?: IStartGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encryptionKey = _data["encryptionKey"];
            if (Array.isArray(_data["chances"])) {
                this.chances = [] as any;
                for (let item of _data["chances"])
                    this.chances!.push(GameChance.fromJS(item));
            }
            this.survey = _data["survey"] ? SurveyQuestionnaire.fromJS(_data["survey"]) : undefined as any;
            if (Array.isArray(_data["vouchersOutOfStock"])) {
                this.vouchersOutOfStock = [] as any;
                for (let item of _data["vouchersOutOfStock"])
                    this.vouchersOutOfStock!.push(ProductInfo.fromJS(item));
            }
            this.calculateWinningChanceServerside = _data["calculateWinningChanceServerside"];
        }
    }

    static fromJS(data: any): StartGame {
        data = typeof data === 'object' ? data : {};
        let result = new StartGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encryptionKey"] = this.encryptionKey;
        if (Array.isArray(this.chances)) {
            data["chances"] = [];
            for (let item of this.chances)
                data["chances"].push(item ? item.toJSON() : undefined as any);
        }
        data["survey"] = this.survey ? this.survey.toJSON() : undefined as any;
        if (Array.isArray(this.vouchersOutOfStock)) {
            data["vouchersOutOfStock"] = [];
            for (let item of this.vouchersOutOfStock)
                data["vouchersOutOfStock"].push(item ? item.toJSON() : undefined as any);
        }
        data["calculateWinningChanceServerside"] = this.calculateWinningChanceServerside;
        return data;
    }
}

export interface IStartGame {
    encryptionKey?: string | undefined;
    chances?: GameChance[] | undefined;
    survey?: SurveyQuestionnaire | undefined;
    vouchersOutOfStock?: ProductInfo[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
}

export class StartGameParam implements IStartGameParam {
    gameId?: string | undefined;
    language?: string | undefined;
    consumerId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IStartGameParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.language = _data["language"];
            this.consumerId = _data["consumerId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StartGameParam {
        data = typeof data === 'object' ? data : {};
        let result = new StartGameParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["language"] = this.language;
        data["consumerId"] = this.consumerId;
        data["status"] = this.status;
        return data;
    }
}

export interface IStartGameParam {
    gameId?: string | undefined;
    language?: string | undefined;
    consumerId?: string | undefined;
    status?: string | undefined;
}

export class SurveyAnswerInfo implements ISurveyAnswerInfo {
    externalId?: string | undefined;
    answerId?: string | undefined;
    answerDescription?: string | undefined;
    language?: string | undefined;

    constructor(data?: ISurveyAnswerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.answerId = _data["answerId"];
            this.answerDescription = _data["answerDescription"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): SurveyAnswerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["answerId"] = this.answerId;
        data["answerDescription"] = this.answerDescription;
        data["language"] = this.language;
        return data;
    }
}

export interface ISurveyAnswerInfo {
    externalId?: string | undefined;
    answerId?: string | undefined;
    answerDescription?: string | undefined;
    language?: string | undefined;
}

export class SurveyCompleted implements ISurveyCompleted {
    userId?: string | undefined;
    id?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;

    constructor(data?: ISurveyCompleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.defaultLanguage = _data["defaultLanguage"];
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(SurveyGameInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyCompleted {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["defaultLanguage"] = this.defaultLanguage;
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyCompleted {
    userId?: string | undefined;
    id?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;
}

export class SurveyGameInfo implements ISurveyGameInfo {
    questionId?: string | undefined;
    questionDescription?: string | undefined;
    multipleChoices?: boolean | undefined;
    answers?: SurveyAnswerInfo[] | undefined;

    constructor(data?: ISurveyGameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionDescription = _data["questionDescription"];
            this.multipleChoices = _data["multipleChoices"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswerInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyGameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyGameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionDescription"] = this.questionDescription;
        data["multipleChoices"] = this.multipleChoices;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyGameInfo {
    questionId?: string | undefined;
    questionDescription?: string | undefined;
    multipleChoices?: boolean | undefined;
    answers?: SurveyAnswerInfo[] | undefined;
}

export class SurveyQuery implements ISurveyQuery {
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: ISurveyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): SurveyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface ISurveyQuery {
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class SurveyQuestionnaire implements ISurveyQuestionnaire {
    adminId?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;

    constructor(data?: ISurveyQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminId = _data["adminId"];
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.defaultLanguage = _data["defaultLanguage"];
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(SurveyGameInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminId"] = this.adminId;
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["defaultLanguage"] = this.defaultLanguage;
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyQuestionnaire {
    adminId?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;
}

export class SurveyQuestionnaireSurveyQueryResponse implements ISurveyQuestionnaireSurveyQueryResponse {
    items?: SurveyQuestionnaire[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: ISurveyQuestionnaireSurveyQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SurveyQuestionnaire.fromJS(item));
            }
            this.total = _data["total"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): SurveyQuestionnaireSurveyQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionnaireSurveyQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface ISurveyQuestionnaireSurveyQueryResponse {
    items?: SurveyQuestionnaire[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;
}

export class UpdateProductRequest implements IUpdateProductRequest {
    productName?: string | undefined;
    productDescription?: string | undefined;
    productPhotoUrl?: string | undefined;

    constructor(data?: IUpdateProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productDescription = _data["productDescription"];
            this.productPhotoUrl = _data["productPhotoUrl"];
        }
    }

    static fromJS(data: any): UpdateProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productDescription"] = this.productDescription;
        data["productPhotoUrl"] = this.productPhotoUrl;
        return data;
    }
}

export interface IUpdateProductRequest {
    productName?: string | undefined;
    productDescription?: string | undefined;
    productPhotoUrl?: string | undefined;
}

export class UpdateRewardDefinitionRequest implements IUpdateRewardDefinitionRequest {
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    customAttributes?: { [key: string]: string; } | undefined;

    constructor(data?: IUpdateRewardDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.rewardType = _data["rewardType"];
            this.price = _data["price"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["advertisers"])) {
                this.advertisers = [] as any;
                for (let item of _data["advertisers"])
                    this.advertisers!.push(RewardAdvertiserDto.fromJS(item));
            }
            this.audienceType = _data["audienceType"];
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.isPopular = _data["isPopular"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            if (_data["customAttributes"]) {
                this.customAttributes = {} as any;
                for (let key in _data["customAttributes"]) {
                    if (_data["customAttributes"].hasOwnProperty(key))
                        (this.customAttributes as any)![key] = _data["customAttributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateRewardDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRewardDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["rewardType"] = this.rewardType;
        data["price"] = this.price;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.advertisers)) {
            data["advertisers"] = [];
            for (let item of this.advertisers)
                data["advertisers"].push(item ? item.toJSON() : undefined as any);
        }
        data["audienceType"] = this.audienceType;
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["isPopular"] = this.isPopular;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        if (this.customAttributes) {
            data["customAttributes"] = {};
            for (let key in this.customAttributes) {
                if (this.customAttributes.hasOwnProperty(key))
                    (data["customAttributes"] as any)[key] = (this.customAttributes as any)[key];
            }
        }
        return data;
    }
}

export interface IUpdateRewardDefinitionRequest {
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    rewardType?: string | undefined;
    price?: number | undefined;
    countryCode?: string | undefined;
    advertisers?: RewardAdvertiserDto[] | undefined;
    audienceType?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    isPopular?: boolean | undefined;
    expirationDate?: Date | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
}

export class UpdateRoutingRuleRequest implements IUpdateRoutingRuleRequest {
    advertiserName?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IUpdateRoutingRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserName = _data["advertiserName"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): UpdateRoutingRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoutingRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserName"] = this.advertiserName;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IUpdateRoutingRuleRequest {
    advertiserName?: string | undefined;
    provider?: string | undefined;
}

export class VoucherDTO implements IVoucherDTO {
    id?: number | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    code1?: string | undefined;
    code2?: string | undefined;
    expirationDate?: Date | undefined;
    orderId?: number | undefined;
    redeemedBy?: string | undefined;
    redeemDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    timestamp?: string | undefined;

    constructor(data?: IVoucherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.code1 = _data["code1"];
            this.code2 = _data["code2"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.orderId = _data["orderId"];
            this.redeemedBy = _data["redeemedBy"];
            this.redeemDate = _data["redeemDate"] ? new Date(_data["redeemDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): VoucherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["code1"] = this.code1;
        data["code2"] = this.code2;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["orderId"] = this.orderId;
        data["redeemedBy"] = this.redeemedBy;
        data["redeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IVoucherDTO {
    id?: number | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    code1?: string | undefined;
    code2?: string | undefined;
    expirationDate?: Date | undefined;
    orderId?: number | undefined;
    redeemedBy?: string | undefined;
    redeemDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    timestamp?: string | undefined;
}

export class VoucherDTOVoucherQueryResponse implements IVoucherDTOVoucherQueryResponse {
    items?: VoucherDTO[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IVoucherDTOVoucherQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VoucherDTO.fromJS(item));
            }
            this.total = _data["total"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): VoucherDTOVoucherQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDTOVoucherQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IVoucherDTOVoucherQueryResponse {
    items?: VoucherDTO[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;
}

export class VoucherPoolDTO implements IVoucherPoolDTO {
    voucherId?: string | undefined;
    rewardId?: string | undefined;
    code1?: string | undefined;
    code1Label?: string | undefined;
    code1UrlText?: string | undefined;
    code2?: string | undefined;
    code2Label?: string | undefined;
    code2UrlText?: string | undefined;
    expirationDate?: Date | undefined;
    orderId?: string | undefined;
    redeemedBy?: string | undefined;
    redeemDate?: Date | undefined;
    isDummy?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IVoucherPoolDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherId = _data["voucherId"];
            this.rewardId = _data["rewardId"];
            this.code1 = _data["code1"];
            this.code1Label = _data["code1Label"];
            this.code1UrlText = _data["code1UrlText"];
            this.code2 = _data["code2"];
            this.code2Label = _data["code2Label"];
            this.code2UrlText = _data["code2UrlText"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.orderId = _data["orderId"];
            this.redeemedBy = _data["redeemedBy"];
            this.redeemDate = _data["redeemDate"] ? new Date(_data["redeemDate"].toString()) : undefined as any;
            this.isDummy = _data["isDummy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherPoolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPoolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherId"] = this.voucherId;
        data["rewardId"] = this.rewardId;
        data["code1"] = this.code1;
        data["code1Label"] = this.code1Label;
        data["code1UrlText"] = this.code1UrlText;
        data["code2"] = this.code2;
        data["code2Label"] = this.code2Label;
        data["code2UrlText"] = this.code2UrlText;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["orderId"] = this.orderId;
        data["redeemedBy"] = this.redeemedBy;
        data["redeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : undefined as any;
        data["isDummy"] = this.isDummy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IVoucherPoolDTO {
    voucherId?: string | undefined;
    rewardId?: string | undefined;
    code1?: string | undefined;
    code1Label?: string | undefined;
    code1UrlText?: string | undefined;
    code2?: string | undefined;
    code2Label?: string | undefined;
    code2UrlText?: string | undefined;
    expirationDate?: Date | undefined;
    orderId?: string | undefined;
    redeemedBy?: string | undefined;
    redeemDate?: Date | undefined;
    isDummy?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export class VoucherPoolDTOVoucherPoolQueryResponse implements IVoucherPoolDTOVoucherPoolQueryResponse {
    items?: VoucherPoolDTO[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IVoucherPoolDTOVoucherPoolQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VoucherPoolDTO.fromJS(item));
            }
            this.total = _data["total"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): VoucherPoolDTOVoucherPoolQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPoolDTOVoucherPoolQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IVoucherPoolDTOVoucherPoolQueryResponse {
    items?: VoucherPoolDTO[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;
}

export class VoucherPoolQuery implements IVoucherPoolQuery {
    rewardId?: string | undefined;
    orderId?: string | undefined;
    code1?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IVoucherPoolQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rewardId = _data["rewardId"];
            this.orderId = _data["orderId"];
            this.code1 = _data["code1"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): VoucherPoolQuery {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPoolQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["orderId"] = this.orderId;
        data["code1"] = this.code1;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IVoucherPoolQuery {
    rewardId?: string | undefined;
    orderId?: string | undefined;
    code1?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class VoucherQuery implements IVoucherQuery {
    productId?: number | undefined;
    code1?: string | undefined;
    code2?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IVoucherQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.code1 = _data["code1"];
            this.code2 = _data["code2"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): VoucherQuery {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["code1"] = this.code1;
        data["code2"] = this.code2;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IVoucherQuery {
    productId?: number | undefined;
    code1?: string | undefined;
    code2?: string | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new SwaggerException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}